import { useAuth } from "@/context/AuthContext";
import { Eye, X } from "lucide-react";

export const PreviewBanner = () => {
  const { preview, previewLabel, exitPreview } = useAuth();
  if (!preview) return null;
  return (
    <div
      data-testid="preview-banner"
      className="w-full bg-amber-400 text-emerald-950 border-b border-amber-500/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-11 flex items-center justify-between text-sm">
        <span className="flex items-center gap-2 font-medium">
          <Eye className="h-4 w-4" />
          Admin Preview Mode — Viewing as {previewLabel}
          <span className="hidden sm:inline text-xs text-emerald-900/70 font-normal">· read-only simulation, no real data is affected</span>
        </span>
        <button
          data-testid="preview-exit"
          onClick={exitPreview}
          className="flex items-center gap-1 rounded-full bg-emerald-950/10 hover:bg-emerald-950/20 px-3 py-1 text-xs font-medium transition-colors"
        >
          <X className="h-3.5 w-3.5" /> Exit preview
        </button>
      </div>
    </div>
  );
};
